import React from 'react'
import { Link } from 'react-router-dom'
import Layout from '../layouts/MainLayout';

export default function AllArrivals() {
  return (
    <Layout>
    <div className='container place-items-center mx-auto gap-x-4 gap-y-4 grid xl:grid-cols-5 xl:gap-x-4 xl:gap-y-8  mt-12 mb-12 lg:gap-x-3 lg:gap-y-8 lg:grid-cols-4 md:gap-x-2 md:gap-y-6 md:grid-cols-3 sm:gap-x-2 sm:gap-y-4 sm:grid-cols-2 '>
<Link to="ArrivalsDetails-1">
<div className="w-full max-w-xs overflow-hidden bg-white rounded-lg shadow-lg dark:bg-gray-800">
    <img className=" max-w-xs hover:scale-110 transition duration-300 ease-in-out object-cover w-full h-56" src="https://www.autoguide.com/blog/wp-content/gallery/2018-geneva-motor-show-mansory/Mansory-Cars-2018-Geneva-Motor-Show-11.jpg" alt="avatar"/>

    <div className="py-5 text-center">
        <h2  className="block text-2xl font-bold text-gray-800 dark:text-white">Mansory</h2>
        <span className="text-sm text-gray-700 dark:text-gray-200">Germany</span>

    </div>
</div>
</Link>

<Link to="ArrivalsDetails-2">
<div className="w-full max-w-xs overflow-hidden bg-white rounded-lg shadow-lg dark:bg-gray-800">
    <img className=" max-w-xs hover:scale-110 transition duration-300 ease-in-out object-cover w-full h-56" src="https://www.autoguide.com/blog/wp-content/gallery/2018-geneva-motor-show-mansory/Mansory-Cars-2018-Geneva-Motor-Show-11.jpg" alt="avatar"/>

    <div className="py-5 text-center">
        <h2  className="block text-2xl font-bold text-gray-800 dark:text-white">Mansory</h2>
        <span className="text-sm text-gray-700 dark:text-gray-200">Germany</span>

    </div>
</div>
</Link>

<Link to="ArrivalsDetails-3">
<div className="w-full max-w-xs overflow-hidden bg-white rounded-lg shadow-lg dark:bg-gray-800">
    <img className=" max-w-xs hover:scale-110 transition duration-300 ease-in-out object-cover w-full h-56" src="https://www.autoguide.com/blog/wp-content/gallery/2018-geneva-motor-show-mansory/Mansory-Cars-2018-Geneva-Motor-Show-11.jpg" alt="avatar"/>

    <div className="py-5 text-center">
        <h2 className="block text-2xl font-bold text-gray-800 dark:text-white">Mansory</h2>
        <span className="text-sm text-gray-700 dark:text-gray-200">Germany</span>

    </div>
</div>
</Link>

<Link to="ArrivalsDetails-4">
<div className="w-full max-w-xs overflow-hidden bg-white rounded-lg shadow-lg dark:bg-gray-800">
    <img className=" max-w-xs hover:scale-110 transition duration-300 ease-in-out object-cover w-full h-56" src="https://www.autoguide.com/blog/wp-content/gallery/2018-geneva-motor-show-mansory/Mansory-Cars-2018-Geneva-Motor-Show-11.jpg" alt="avatar"/>

    <div className="py-5 text-center">
        <h2 className="block text-2xl font-bold text-gray-800 dark:text-white">Mansory</h2>
        <span className="text-sm text-gray-700 dark:text-gray-200">Germany</span>

    </div>
</div>
</Link>

<Link to="ArrivalsDetails-5">
<div className="w-full max-w-xs overflow-hidden bg-white rounded-lg shadow-lg dark:bg-gray-800">
    <img className=" max-w-xs hover:scale-110 transition duration-300 ease-in-out  object-cover w-full h-56" src="https://www.autoguide.com/blog/wp-content/gallery/2018-geneva-motor-show-mansory/Mansory-Cars-2018-Geneva-Motor-Show-11.jpg" alt="avatar"/>

    <div className="py-5 text-center">
        <h2 className="block text-2xl font-bold text-gray-800 dark:text-white">Mansory</h2>
        <span className="text-sm text-gray-700 dark:text-gray-200">Germany</span>

    </div>
</div>
</Link>


<Link to="ArrivalsDetails-6">
<div className="w-full max-w-xs overflow-hidden bg-white rounded-lg shadow-lg dark:bg-gray-800">
    <img className="max-w-xs hover:scale-110 transition duration-300 ease-in-out  object-cover w-full h-56" src="https://www.autoguide.com/blog/wp-content/gallery/2018-geneva-motor-show-mansory/Mansory-Cars-2018-Geneva-Motor-Show-11.jpg" alt="avatar"/>

    <div className="py-5 text-center">
        <h2 className="block text-2xl font-bold text-gray-800 dark:text-white">Mansory</h2>
        <span className="text-sm text-gray-700 dark:text-gray-200">Germany</span>

    </div>
</div>
</Link>

<Link to="ArrivalsDetails-7">
<div className="w-full max-w-xs overflow-hidden bg-white rounded-lg shadow-lg dark:bg-gray-800">
    <img className=" max-w-xs hover:scale-110 transition duration-300 ease-in-out object-cover w-full h-56" src="https://www.autoguide.com/blog/wp-content/gallery/2018-geneva-motor-show-mansory/Mansory-Cars-2018-Geneva-Motor-Show-11.jpg" alt="avatar"/>

    <div className="py-5 text-center">
        <h2 className="block text-2xl font-bold text-gray-800 dark:text-white">Mansory</h2>
        <span className="text-sm text-gray-700 dark:text-gray-200">Germany</span>

    </div>
</div>
</Link>

<Link to="ArrivalsDetails-8">
<div className="w-full max-w-xs overflow-hidden bg-white rounded-lg shadow-lg dark:bg-gray-800">
    <img className=" max-w-xs hover:scale-110 transition duration-300 ease-in-out object-cover w-full h-56" src="https://www.autoguide.com/blog/wp-content/gallery/2018-geneva-motor-show-mansory/Mansory-Cars-2018-Geneva-Motor-Show-11.jpg" alt="avatar"/>

    <div className="py-5 text-center">
        <h2 className="block text-2xl font-bold text-gray-800 dark:text-white">Mansory</h2>
        <span className="text-sm text-gray-700 dark:text-gray-200">Germany</span>

    </div>
</div>
</Link>

<Link to="ArrivalsDetails-9">
<div className="w-full max-w-xs overflow-hidden bg-white rounded-lg shadow-lg dark:bg-gray-800">
    <img className=" max-w-xs hover:scale-110 transition duration-300 ease-in-out object-cover w-full h-56" src="https://www.autoguide.com/blog/wp-content/gallery/2018-geneva-motor-show-mansory/Mansory-Cars-2018-Geneva-Motor-Show-11.jpg" alt="avatar"/>

    <div className="py-5 text-center">
        <h2 className="block text-2xl font-bold text-gray-800 dark:text-white">Mansory</h2>
        <span className="text-sm text-gray-700 dark:text-gray-200">Germany</span>

    </div>
</div>
</Link>
<Link to="ArrivalsDetails-10">
<div className="w-full max-w-xs overflow-hidden bg-white rounded-lg shadow-lg dark:bg-gray-800">
    <img className=" max-w-xs hover:scale-110 transition duration-300 ease-in-out object-cover w-full h-56" src="https://www.autoguide.com/blog/wp-content/gallery/2018-geneva-motor-show-mansory/Mansory-Cars-2018-Geneva-Motor-Show-11.jpg" alt="avatar"/>

    <div className="py-5 text-center">
        <h2 className="block text-2xl font-bold text-gray-800 dark:text-white">Mansory</h2>
        <span className="text-sm text-gray-700 dark:text-gray-200">Germany</span>

    </div>
</div>
</Link>

<Link to="ArrivalsDetails-11">
<div className="w-full max-w-xs overflow-hidden bg-white rounded-lg shadow-lg dark:bg-gray-800">
    <img className="max-w-xs hover:scale-110 transition duration-300 ease-in-out  object-cover w-full h-56" src="https://www.autoguide.com/blog/wp-content/gallery/2018-geneva-motor-show-mansory/Mansory-Cars-2018-Geneva-Motor-Show-11.jpg" alt="avatar"/>

    <div className="py-5 text-center">
        <h2 className="block text-2xl font-bold text-gray-800 dark:text-white">Mansory</h2>
        <span className="text-sm text-gray-700 dark:text-gray-200">Germany</span>

    </div>
</div>
</Link>

<Link to="ArrivalsDetails-12">
<div className="w-full max-w-xs overflow-hidden bg-white rounded-lg shadow-lg dark:bg-gray-800">
    <img className="  max-w-xs hover:scale-110 transition duration-300 ease-in-out object-cover w-full h-56" src="https://www.autoguide.com/blog/wp-content/gallery/2018-geneva-motor-show-mansory/Mansory-Cars-2018-Geneva-Motor-Show-11.jpg" alt="avatar"/>

    <div className="py-5 text-center">
        <h2 className="block text-2xl font-bold text-gray-800 dark:text-white">Mansory</h2>
        <span className="text-sm text-gray-700 dark:text-gray-200">Germany</span>

    </div>
</div>
</Link>


    </div>
    </Layout>
  )
}
